import SuccessCasesSection from "../sections/Home/SuccessCasesSection";
import HeroSection from "../sections/Home/HeroSection";
import ContactSection from "../sections/Home/ContactSection";
import MainLayout from "../components/MainLayout";
// import Lab5GSection from "../sections/Home/Lab5GSection";
import Learn5GSection from '../sections/Home/Learn5GSection';

function HomePage() {
  return (
    <MainLayout>
      <div>
        <HeroSection />
      </div>
      <div>
        <Learn5GSection />
      </div>
      <div>
        <SuccessCasesSection />
      </div>
      <div>
        {/* <Lab5GSection /> */}
      </div>
      <div>
        <ContactSection />
      </div>
    </MainLayout>
  );
}

export default HomePage;
